import { call, select } from 'redux-saga/effects';

import { logException, logMessage } from 'ctm-util-functions';
import { transactionPayloadSelector } from 'ctm-selectors';

import { reporterLog } from './reporter';

/**
 * @desc generator to catch all error logging actions, and handle them appropriately.
 * @param {Object} action     - The dispatched action that contains the description of error logging process.
 * @returns {Boolean}         - True if the generator completed successfully, otherwise false.
 */
export const errorLogging = function* (action = {}) {
    try {
        let userId = '';
        switch (action.type) {
            case 'SET_LOGGING_IDENTIFY': {
                const tranData = yield select(transactionPayloadSelector);
                userId = `${tranData?.get('accountId')}-${tranData?.get('journeyId')}`;
                if (typeof window !== 'undefined' && window.Raven) {
                    window.Raven.setTagsContext({ vertical: action.verticalStateKey, userId });
                }
                break;
            }
            default: {
                return false;
            }
        }
    } catch (error) {
        // Log the error using the reporter.
        yield call(reporterLog, action, error);
        // Sentry error logging
        yield call(logException, error, 'error', { action });
    }
    return true;
};
